// extracted by mini-css-extract-plugin
export var aside = "styles-module--aside--2HCWs";
export var aside_inner = "styles-module--aside_inner--i1oHR";
export var aside_links = "styles-module--aside_links--2ymp7";